export class BNLForms {
	init() {
		const epiForms = document.querySelectorAll<HTMLFormElement>(
			"form.EPiServerForms"
		);

		epiForms.forEach(epiForm => {
			// EPiServer adds all the date inputs as text inputs. So we can use the built in date picker we will change the type.
			const dateInputs = epiForm.querySelectorAll<HTMLInputElement>(
				"*[class*='FormDate'] input"
			);
			dateInputs.forEach(dateInput => {
				dateInput.type = "date";
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const forms = new BNLForms();
	forms.init();
});
